webpackJsonp([191319344601756],{

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 2/4/18
	 */
	var Contact = function Contact(_ref) {
	  var email = _ref.email,
	      description = _ref.description;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'content',
	      style: { border: '1px solid #eaecee', padding: '2em 4em' } },
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:' + email },
	        email
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      description
	    )
	  );
	};
	
	Contact.propTypes = {
	  email: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contactPageQuery = exports.ContactPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Contact = __webpack_require__(139);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 2/4/18
	 */
	var ContactPageTemplate = exports.ContactPageTemplate = function ContactPageTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      meta_title = _ref.meta_title,
	      meta_description = _ref.meta_description,
	      contacts = _ref.contacts;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta_description })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-bold' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'title' },
	                  title
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'subtitle' },
	                  subtitle
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        contacts.map(function (contact, id) {
	          return _react2.default.createElement(_Contact2.default, { key: id, email: contact.email, description: contact.description });
	        })
	      )
	    )
	  );
	};
	
	ContactPageTemplate.propTypes = {
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  meta_title: _propTypes2.default.string,
	  meta_description: _propTypes2.default.string,
	  contacts: _propTypes2.default.array
	
	};
	
	var ContactPage = function ContactPage(_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	
	  return _react2.default.createElement(ContactPageTemplate, {
	    title: frontmatter.title,
	    subtitle: frontmatter.subtitle,
	    meta_title: frontmatter.meta_title,
	    meta_description: frontmatter.meta_description,
	    contacts: frontmatter.contacts
	  });
	};
	
	ContactPage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = ContactPage;
	var contactPageQuery = exports.contactPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-contact-page-js-8913153e22bba55b7f2c.js